import PropTypes from "prop-types";
import Person2Icon from "@mui/icons-material/Person2";

import StarringYouPresenter from "presenters/StarringYouPresenter";

import DeviceBadge from "../DeviceBadge";

import { Container, BadgeContainer, StyledChip, Title } from "./styles";

const Details = ({ item, imageWidth }) => {
  return (
    <Container>
      <BadgeContainer>
        <StyledChip icon={<Person2Icon />} label={StarringYouPresenter.formatCastOptions(item)} />
        <DeviceBadge type={StarringYouPresenter.deviceType(item)} />
      </BadgeContainer>
      <Title width={imageWidth}>{StarringYouPresenter.name(item)}</Title>
    </Container>
  );
};

Details.propTypes = {
  item: StarringYouPresenter.shape(),
  imageWidth: PropTypes.number.isRequired,
};

export default Details;
